import { IDialogsState, IRootState } from '../../models';

export const selectDialogsState = (rootState: IRootState): IDialogsState => rootState.dialogsState;
